import type { Icon } from "@phosphor-icons/react";
import { type ButtonHTMLAttributes, forwardRef } from "react";
import { cn } from "~/foundation/utils/cn";

export interface IconButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  icon: Icon;
  /** Required — an icon-only control with no accessible name is a bug, not a style choice. */
  "aria-label": string;
  size?: "sm" | "md";
  iconSize?: number;
  active?: boolean;
}

export const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(function IconButton(
  { icon: IconComponent, size = "md", iconSize, active, className, ...rest },
  ref,
) {
  return (
    <button
      ref={ref}
      type="button"
      className={cn(
        "inline-flex shrink-0 items-center justify-center rounded-sm cursor-pointer",
        "text-text-secondary hover:bg-hover-bg hover:text-text",
        "transition-colors duration-100 ease-in-out motion-reduce:transition-none",
        "disabled:opacity-50 disabled:pointer-events-none",
        size === "sm" ? "size-7" : "size-8",
        active && "bg-hover-bg text-text",
        className,
      )}
      {...rest}
    >
      <IconComponent size={iconSize ?? (size === "sm" ? 16 : 18)} aria-hidden />
    </button>
  );
});
